import { FlowDurationUnits } from './duration.js';
/**
 * Note - this does not account for DST transitions, or leap years.
 * Regarding DST transitions:
 * 1 day in milliseconds is not the same for a DST transition.
 * 1 day for the switch from standard time to DST is 23 hours.
 * 1 day for the switch from DST to standard time is 25 hours.
 * If you need to account for correct date durations, use date-fns Date math utilities,
 * such as https://date-fns.org/v4.1.0/docs/add
 */
export function getFlowDurationInMillis(value, unit) {
    const durationsInSeconds = {
        seconds: 1,
        minutes: 60,
        hours: 60 * 60,
        days: 24 * 60 * 60, // Approximate (Not valid for DST transitions)
        weeks: 7 * 24 * 60 * 60, // Approximate (Not valid for DST transitions)
        years: 365 * 24 * 60 * 60, // Approximate (Not valid for leap years)
    };
    return value * 1000 * durationsInSeconds[unit];
}
/**
 * Note - this does not account for DST transitions, or leap years.
 * Regarding DST transitions:
 * 1 day in milliseconds is not the same for a DST transition.
 * 1 day for the switch from standard time to DST is 23 hours.
 * 1 day for the switch from DST to standard time is 25 hours.
 * If you need to account for correct date durations, use date-fns Date math utilities,
 * such as https://date-fns.org/v4.1.0/docs/add
 */
export function convertFlowDurationToMilliseconds(duration) {
    return getFlowDurationInMillis(duration.value, duration.units);
}
export function convertMillisecondsToFlowDuration(args) {
    const { value, units = FlowDurationUnits.Seconds } = args;
    const seconds = value / 1000;
    switch (units) {
        case FlowDurationUnits.Years:
            return {
                value: seconds / (60 * 60 * 24 * 365),
                units: FlowDurationUnits.Years,
            };
        case FlowDurationUnits.Weeks:
            return {
                value: seconds / (60 * 60 * 24 * 7),
                units: FlowDurationUnits.Weeks,
            };
        case FlowDurationUnits.Days:
            return {
                value: seconds / (60 * 60 * 24),
                units: FlowDurationUnits.Days,
            };
        case FlowDurationUnits.Hours:
            return {
                value: seconds / (60 * 60),
                units: FlowDurationUnits.Hours,
            };
        case FlowDurationUnits.Minutes:
            return {
                value: seconds / 60,
                units: FlowDurationUnits.Minutes,
            };
        case FlowDurationUnits.Seconds:
            return {
                value: seconds,
                units: FlowDurationUnits.Seconds,
            };
    }
}
//# sourceMappingURL=convert.js.map